import { render, staticRenderFns } from "./RegistrarDevolucionItems.vue?vue&type=template&id=da89f3d2&scoped=true&"
import script from "./RegistrarDevolucionItems.vue?vue&type=script&lang=js&"
export * from "./RegistrarDevolucionItems.vue?vue&type=script&lang=js&"
import style0 from "./RegistrarDevolucionItems.vue?vue&type=style&index=0&id=da89f3d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da89f3d2",
  null
  
)

export default component.exports